import Products from './components/Products.svelte';
import Projects from './components/Projects.svelte';
import EditProject from './components/Projects/EditProject.svelte';

export default {
    '/': Products,
    '/products': Products,
    '/projects': Projects,
    '/project/edit/:id': EditProject,
    '*': Products
};
